/** Substatus tags (LAM-5473): roster-derived, read-only chips projected onto grid rows by the server. */
/** Pills are single-line; a roster free-text value gets cut here and shown whole on hover. */
export const SUBSTATUS_DISPLAY_MAX_LENGTH = 32;
function truncate(value) {
    return value.length > SUBSTATUS_DISPLAY_MAX_LENGTH ? `${value.slice(0, SUBSTATUS_DISPLAY_MAX_LENGTH - 1)}…` : value;
}
/**
 * URL form of the substatus filter: `key:value` pairs, comma-joined, with key and value each
 * percent-encoded separately so the bare `:` and `,` stay structural (a key or value's own colon
 * travels as %3A). Mirrors split_substatus_param on the server, which also locates the structural
 * colon before decoding; `key:` (an empty value) selects the blank cell.
 */
export function makeSubstatusPair(key, value) {
    return `${encodeURIComponent(key)}:${encodeURIComponent(value)}`;
}
/** The pair's decoded sides, or null for a chunk a truncated or hand-edited URL left malformed. */
export function parseSubstatusPair(pair) {
    const colon = pair.indexOf(":");
    if (colon < 0)
        return null;
    try {
        return { key: decodeURIComponent(pair.slice(0, colon)), value: decodeURIComponent(pair.slice(colon + 1)) };
    }
    catch {
        // decodeURIComponent throws on a dangling "%", and this runs inside render-path computeds.
        return null;
    }
}
export function joinSubstatusPairs(pairs) {
    return pairs.join(",");
}
export function splitSubstatusPairs(joined) {
    if (!joined)
        return [];
    return joined.split(",").filter((chunk) => parseSubstatusPair(chunk) !== null);
}
/**
 * TagChips inputs for a row's substatus values: one synthetic definition per chip labelled "Field: Value",
 * so the column shares the tag pill look without a second stylesheet. Values whose definition was deleted
 * are dropped, mirroring how TagChips treats an unknown tag key.
 */
export function substatusChipDefs(tags, definitions) {
    const byKey = new Map((definitions || []).map((d) => [d.key, d]));
    const defs = [];
    for (const tag of tags || []) {
        const def = byKey.get(tag.key);
        if (!def || !tag.value)
            continue;
        defs.push({
            key: tag.key,
            label: `${def.label}: ${truncate(tag.value)}`,
            title: `${def.label}: ${tag.value}`,
            color: def.color,
        });
    }
    return defs;
}
